import styled_components from "styled-components";
import { Box } from "pcln-design-system";
const ErrorImgWrapper = /*#__PURE__*/ styled_components.div.withConfig({
    displayName: "ErrorComponent.styles__ErrorImgWrapper"
})([
    "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;"
]);
const ErrorTextWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "ErrorComponent.styles__ErrorTextWrapper"
})([
    "position:absolute;bottom:20px;left:0;right:0;box-sizing:border-box;z-index:1;span{font-weight:bold;}"
]);
export { ErrorImgWrapper, ErrorTextWrapper };
